//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"LifterBodies",0,"SelectDisplayableObjectList",0],[1,"LifterDriveBodies",0,"SelectDisplayableObjectList",0],[0,"LifterDriveVector",1,"Direction",0],[0,"LifterName",1,0],[1,"LifterOnBodies",0,"SelectDisplayableObjectList",0],[0,"LifterOnDriveVector",1,"Direction",0],[0,"LifterOnLifterVector",1,"Direction",0],[0,"LifterOnName",1,0],[0,"LifterVector",1,"Direction",0],[1,"MainLifterBodies",0,"SelectDisplayableObjectList",0],[1,"MainLifterDriveBodies",0,"SelectDisplayableObjectList",0],[0,"MainLifterDriveVector",1,"Direction",0],[0,"MainLifterVector",1,"Direction",0],[0,"Type",1,0]],[[["lifterName"],"DeleteGenericLifter",{},1,0],[["lifterName"],"DeleteLifterOnLifter",{},1,0]],[]];
SPLM.Tooling.DefineLifterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DefineLifterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DefineLifterBuilder.Types = Object.freeze({
    "GenericLifter" : "GenericLifter", "LifteronLifter" : "LifteronLifter"});

export default SPLM;